import api from "../Base";
import AlertRules from "../../types/Alerts/AlertRules";
import AlertActions from "../../types/Alerts/AlertActions";
import { showError } from "../../utils/showAlert";

const AlertApi = {

    async makeAlertApiCall(url: string) {
        let alerts: any = [];

        await api.get(url)
            .then((response: { data: any; }) => {
                alerts = response.data;
            })
            .catch((error: any) => {
                console.log('An error occurred:', error);
                showError('An error occurred', error.message || error.toString());
            });

        return alerts
    },

    getAlertRules:async () => {
        let url = `/alert/rule`;
        let alertRules: AlertRules[] = [];

        await api.get<AlertRules[]>(url)
            .then((response) => {
                alertRules = response.data;
            })
            .catch((error: any) => {
                console.error('Failed to retrieve alert rules.', error);
                showError('Failed to retrieve alert rules', error.message || error.toString());
            });
        return alertRules;
    },

    getAlertActions:async () => {
        let url = `/alert/action`;
        let alertActions: AlertActions[] = [];

        await api.get<AlertActions[]>(url)
            .then((response) => {
                alertActions = response.data;
            })
            .catch((error: any) => {
                console.error('Failed to retrieve alert actions.', error);
                showError('Failed to retrieve alert actions', error.message || error.toString());
            });
        return alertActions;
    },
}

export default AlertApi;